import React from "react";
import Scrollspy from 'react-scrollspy';
import { FiX , FiMenu } from "react-icons/fi";
import {useTranslation} from "react-i18next";
import {useMediaQuery} from "react-responsive";

const Header = () => {
  const { t, i18n } = useTranslation();
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const currentLanguage = i18n.language;
  const languages = ['en', 'ru'];
  const showedLanguage: string = languages.filter((language => language !== currentLanguage))[0]

  const onChangeLanguage = (selectedLanguage: string) => {
    i18n.changeLanguage(selectedLanguage)
  };

  window.addEventListener('load', function() {
    console.log('All assets are loaded');
  })
  function menuTrigger() {
    document.querySelector('.header-wrapper')!.classList.toggle('menu-open')
  }
  function CLoseMenuTrigger() {
    document.querySelector('.header-wrapper')!.classList.remove('menu-open')
  }

  window.addEventListener('scroll', function() {
    let value = window.scrollY;
    if (value > 100) {
      document.querySelector('.header--fixed')!.classList.add('sticky')
    }else{
      document.querySelector('.header--fixed')!.classList.remove('sticky')
    }
  });

  return(
      <header className="header-area formobile-menu header--fixed default-color">
        <div className="header-wrapper" id="header-wrapper">
          <div className="header-left">
            <div className="logo">
              <img className="logo-1" src="/assets/images/logo/logo.svg" alt="Logo Image"/>
            </div>
          </div>
          <div className="header-right">
            <nav className="mainmenunav d-lg-block">
              <Scrollspy className="mainmenu" items={['home', 'about', 'service', 'testimonial', 'contact']} currentClassName="is-current" offset={-200}>
                <li><a href="#home">{t("header.home")}</a></li>
                <li><a href="#about">{t("header.about")}</a></li>
                <li><a href="#service">{t("header.services")}</a></li>
                {/*<li><a href="#process">{t("header.process")}</a></li>*/}
                <li><a href="#testimonial">{t("header.testimonial")}</a></li>
                <li><a href="#contact" className={ isMobile ? '' : 'rn-btn'}>{t("header.contact")}</a></li>
                <li><a className="language-switcher" onClick={() => onChangeLanguage(showedLanguage)}>{t(`languages.${showedLanguage}`)}</a></li>
              </Scrollspy>
            </nav>
            {/* Start Humberger Menu  */}
            <div className="humberger-menu d-block d-lg-none pl--20">
              <span onClick={menuTrigger} className="menutrigger text-white"><FiMenu /></span>
            </div>
            {/* End Humberger Menu  */}
            <div className="close-menu d-block d-lg-none">
              <span onClick={CLoseMenuTrigger} className="closeTrigger"><FiX /></span>
            </div>
          </div>
        </div>
      </header>
  )
}

export default Header;
